import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./UnauthorizedUser.css";
import { Image, Spinner } from "react-bootstrap";
import HomePageIcon from "../Page Not Found/HomePageIcon.png";
import SEO from "../../SEO";

const LoadingSpinner = () => {
  return (
    <Spinner animation="border" role="status">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  );
};

const UnauthorizedUser = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const handleGoHome = () => {
    navigate("/");
  };

  useEffect(() => {
    // Simulate a network check
    const timer = setTimeout(() => {
      setIsLoading(false); // Set loading to false after 2 seconds
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="unauthorized-container">
      <SEO
        title="Unauthorized User"
        description="Experience the best massage and therapy treatments at ShriKrishnaArogyam."
        keywords="spa, massage, therapy, wellness"
      />
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <Image
            src={HomePageIcon}
            alt="Go Home"
            className="home-page-icon"
            onClick={handleGoHome}
          />
        </>
      )}
    </div>
  );
};

export default UnauthorizedUser;
